export const awsAuthConfig = {
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_USERPOOLID,
            userPoolClientId: process.env.REACT_APP_USERPOOLWEBCLIENTID,
            allowGuestAccess: false,
            signUpVerificationMethod: 'link'
        }
    }
};

export const isConfigured = Boolean(
    process.env.REACT_APP_BASE_URL &&
    process.env.REACT_APP_USERPOOLID &&
    process.env.REACT_APP_USERPOOLWEBCLIENTID
);
